import React, { useLayoutEffect, useRef } from "react";
import "./style.scss";
import cn from "classnames";
import { colors } from "../../../assets/colors/colors";
import { Typography } from "../Typography/Typography";

const fitTextarea = (element) => {
  const minHeight = parseFloat(getComputedStyle(element).minHeight) || 0;
  element.style.height = `${minHeight}px`;
  if (element.scrollHeight <= element.clientHeight) return;
  const border = element.offsetHeight - element.clientHeight;
  element.style.height = `${element.scrollHeight + border}px`;
};

export const Textarea = (props) => {
  const textareaRef = useRef(null);
  const classNames = cn(
    "textarea-common-component_placeholder",
    props.value && "textarea-common-component_placeholder_isValue",
    props.disabled && "textarea-common-component_placeholder_disabled",
  );

  useLayoutEffect(() => {
    if (props.autoGrow && textareaRef.current) fitTextarea(textareaRef.current);
  }, [props.autoGrow, props.value]);

  return (
    <div
      className={cn("textarea-common-component", {
        "textarea-common-component_error": props.error,
      })}
      tabIndex="-1"
    >
      <textarea
        ref={textareaRef}
        className={cn(
          "textarea-common-component_textarea",
          props.autoGrow && "textarea-common-component_textarea_auto-grow",
          props.className,
        )}
        value={props.value}
        rows={props.autoGrow ? 1 : undefined}
        onKeyPress={props.onKeyPress}
        disabled={props.disabled}
        maxLength={props.maxLength || 255}
        onChange={props.onChange}
        onBlur={props.onBlur}
      />
      <span className={classNames}>{props.placeholder}</span>
      {props.textError && (
        <Typography
          variant="h5"
          color={colors.redError}
          text={props.textError}
          className="app-container-request_header-panel_wrapper-titles_title"
        />
      )}
    </div>
  );
};
